export class CampaignRequest {
  offset: number = 0;
  limit: number = 25;
  draft: boolean = false;
  archived: boolean = false;
  sortField: string = 'created';
  ascendingSorting: boolean = false;
}
